import { render } from "./field_submitter.vue?vue&type=template&id=99f55b3c"
import script from "./field_submitter.vue?vue&type=script&lang=js"
export * from "./field_submitter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__